import React, {useEffect, useRef, useState} from 'react';
import {Col, Row} from 'components/Grid';
import AuthFormsWrapper from "componentsShared/AuthFormsWrapper";
import Alert from "components/Alert";
import Form, {FormItem} from "components/Form";
import {TextField} from "components/TextField";
import useForm from "hooks/useForm";
import {TResetPasswordFormUI} from "data/types/auth.types";
import {Link, useHistory} from "react-router-dom";
import {useResetPasswordAmplifyMutation,} from "redux/apiSlices/auth.slice";
import get from "lodash/get";
import Button from "components/Button";
import {Paragraph, Text, Title} from "components/Typography";
import {Colors} from "styles/CssVariables";
import {RoutesNames} from 'routes/RoutesNames';
import {resetPasswordFormData} from './ResetPasswordForm.data';


const {code, password, passwordConfirm,passwordAdmin} = resetPasswordFormData;

const ResetPasswordForm = ({email,isAdmin}: { email: string, isAdmin: boolean }) => {
    const history = useHistory();
    const {form} = useForm<TResetPasswordFormUI>();
    const [error, setError] = useState<string>('');
    const [resetPassword, {isLoading}] = useResetPasswordAmplifyMutation();
    const alertRef = useRef<HTMLDivElement | null>(null);
    const onSubmit = async (values: TResetPasswordFormUI) => {
        try {
            await resetPassword({...values, email}).unwrap();
            setError('');
            history.push('/')
        } catch (err) {
            const message = get(err, ['data', 'message']) || 'Something went wrong!';
            setError(message);
        }
    }
    useEffect(() => {
        if (error) {
            alertRef.current?.scrollIntoView({block: 'end'})
        }
    }, [error])
    return (
        <Row justify='center'>
            <AuthFormsWrapper title='Pick a new password.'>
                <Title fontLevel={5} className='mb-6'>Confirm your password below..</Title>
                <Form form={form} onFinish={onSubmit} requiredMark={false} scrollToFirstError>
                    <Row>
                        <Col span={24} ref={alertRef}>
                            <Alert type='error' message={error}/>
                        </Col>
                        <Col span={24}>
                            <FormItem name={code.name} rules={code.rules} label={code.label}>
                                <TextField placeholder={code.placeholder} />
                            </FormItem>
                        </Col>
                        <Col span={24}>
                            <FormItem name={isAdmin?passwordAdmin.name:password.name} rules={isAdmin?passwordAdmin.rules:password.rules} label={password.label}>
                                <TextField placeholder={password.placeholder} type='password'/>
                            </FormItem>
                        </Col>
                        <Col span={24}>
                            <FormItem name={passwordConfirm.name} rules={passwordConfirm.rules}
                                      label={passwordConfirm.label}>
                                <TextField placeholder={passwordConfirm.placeholder} type='password'/>
                            </FormItem>
                        </Col>
                        <Col span={24}>
                            <Button htmlType='submit' loading={isLoading}>Reset</Button>
                            <Paragraph className='mt-2' fontLevel={5}>
                                Go back to{' '}
                                <Text fontLevel={5} color={Colors.DarkBlue} underline>
                                    <Link to={RoutesNames.SignIn}> Login page</Link>
                                </Text>
                            </Paragraph>
                        </Col>
                    </Row>
                </Form>
            </AuthFormsWrapper>
        </Row>
    );
};

export default ResetPasswordForm
